import { render, staticRenderFns } from "./BranchOfficeModal.vue?vue&type=template&id=0b23175f&scoped=true&"
import script from "./BranchOfficeModal.vue?vue&type=script&lang=js&"
export * from "./BranchOfficeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23175f",
  null
  
)

export default component.exports